export const getFormToolRtlProperties = (isRtl) => (
  isRtl ? {
    labelAlign: { value: 'right' },
    fieldAlign: { value: 'right' },
  } : {}
)
